import { render, staticRenderFns } from "./attachmentsUploadPreview.vue?vue&type=template&id=5b7f2297"
import script from "./attachmentsUploadPreview.vue?vue&type=script&lang=ts"
export * from "./attachmentsUploadPreview.vue?vue&type=script&lang=ts"
import style0 from "./attachmentsUploadPreview.vue?vue&type=style&index=0&id=5b7f2297&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports